$(window).on('load', function () {
    const dimmingMainContent = '<div class="bg_modal_window"></div>';

    $(document).on('click', '.bg_modal_window', function () {
        $('.bg_modal_window').remove();
        $('.js_button_tab').removeClass('active');
        $('.tab_my_garage').removeClass('active');
        $('.js_activ_button').removeClass('active')
        $('.filter_wrapper').removeClass('active');
        $('.non_block_for_views').addClass('d_none');
        $('.selected_cars button').removeClass('active');
    });


    $(document).on('click', '.js_button_tab', function () {
        const nameButton = $(this).attr('data-nameTab');

        if ($('.js_garage_in_page').length != 1) {
            $('.filter_wrapper').addClass('active')

            if ($(this).hasClass('active')) {
                $('.js_button_tab').removeClass('active');
                $('.tab_my_garage').removeClass('active');
            } else {
                if ($(window).width() > 768 && $('.bg_modal_window').length == 0) {
                    $('footer').after(dimmingMainContent);
                }
                $('.tab_my_garage').removeClass('active');
                $(this).addClass('active');
                $(`#${nameButton}`).addClass('active');
            }
        } else {
            if ($(this).hasClass('active')) {
                $('.js_button_tab').removeClass('active');
                $('.tab_my_garage').removeClass('active');
            } else {
                $('.js_button_tab').removeClass('active');
                $('.tab_my_garage').removeClass('active');

                $(this).addClass('active');
                $(`#${nameButton}`).addClass('active');
            }
        }

        activeTabFirst();
    });

    $(document).on('click', '.input_search_my_garage', function () {
        const blockOnSearch = $(this).closest('.tab_my_garage').find('.list_filter button');
        $(this).keyup(function () {
            var filter = jQuery(this).val();

            blockOnSearch.each(function () {
                if (jQuery(this).text().search(new RegExp(filter, "i")) < 0) {
                    jQuery(this).hide();
                } else {
                    jQuery(this).show()
                }
            });
        });
    });

    $(document).on('click', '.js__my_garage_header_modal_close', function () {
        const wrapper = $(this).closest('.tab_my_garage');
        const tabNmae = wrapper.attr('id');

        wrapper.removeClass('active');

        $(`.js_button_tab[data-nametab=${tabNmae}]`).removeClass('active');
    })

    //mob_garage

    $(document).on('click', '.js_activ_button', function () {
        $('.filter_wrapper').toggleClass('active');
        const name = $(this).attr('data-buttonName');

        if (name == 'js__add_car_in_garage') {
            $('.add_new_car').toggleClass('activ_mobal')
        }


        if ($(this).hasClass('active')) {
            $('.bg_modal_window').remove();
            $('.filter_wrapper').removeClass('active');
            $('.non_block_for_views').addClass('d_none');
            $('.js_activ_button').removeClass('active');
        } else {
            $('.bg_modal_window').remove();
            if ($(window).width() >= 768) {
                $('footer').after(dimmingMainContent);
            }
            $('.non_block_for_views').addClass('d_none');
            $('.js_activ_button').removeClass('active');

            $('.filter_wrapper').addClass('active');
            $(this).addClass('active');
            $(`.${name}`).removeClass('d_none');
        }
    });

    $(document).on('click', '.js_open_garage_mobile', function () {
        $('.filter_wrapper').toggleClass('activ_mobal');
        $('body').toggleClass('overflow_hidden');
    });

    activeMyGarage();
    activeHoverMainPageMenu();
});



$(document).ready(function () {
    $(document).on('click', '.js__garage_select', function () {
        const parentBlock = $(this).closest('.tab_my_garage'),
            titleButton = $(this).find('span').text(),
            nameTab = parentBlock.attr('id');

        let id = $(this).attr('data-value'),
            target_type = $(this).attr('data-target_type');

        let page = ($('.js_garage_user_account').length != 0)
            ? 'user_page'
            : '';

        parentBlock.find('.js__garage_select').removeClass('active');
        $(`.js_button_tab[data-nametab=${nameTab}] span`).text(titleButton);
        $(this).addClass('active');

        $.post(request.loadGarageData, {
            "parent_id": id,
            "target_type": target_type,
            "type_menu_build": typeof type_menu_build !== 'undefined' ? type_menu_build : undefined,
            "page": page
        }, function (data) {
            if (data.status == 'ok') {
                $('.js_button_tab').removeClass('active');
                $('.tab_my_garage').removeClass('active');

                const wrapperGarage = $(`${data.target_container}`);
                const wrapperGarageList = $(`${data.target_container} .js__append_garage`);

                if (data.target_container) {
                    $(`.js_button_tab[data-nameTab=${data.target_container.substr(1)}]`)
                        .addClass('active').attr('disabled', false);
                }

                (wrapperGarageList.length == 1)
                    ? wrapperGarageList.find('.list_filter').remove()
                    : null;

                wrapperGarage.addClass('active');
                wrapperGarageList.append(data.html);

                for (var i = data.to_empty_containers.length - 1; i >= 0; i--) {
                    $(`${data.to_empty_containers[i]} .js__append_garage`).empty();
                    if (data.to_empty_containers.length != 0) {
                        const buttonTub = $(
                            `.js_button_tab[data-nametab=${data.to_empty_containers[i].substr(1)}]`
                        );
                        buttonTub.find('span').text(buttonTub.attr('data-title'))
                    }
                }

                if ($('.js_brand_id[data-modelId]').length == 1) {
                    activeMyGarage(true);
                }

                if (data.reload == 1) {
                    $("#js__view_garage").empty().append(data.html);
                    if ($('.js__catalog_main_page').length > 0) {
                        $('.js__catalog_main_page').empty().append(data.menu);
                        activeHoverMainPageMenu();
                    }
                    $('.bg_modal_window').trigger('click');
                    $('body').removeClass('overflow_hidden');

                    if (typeof reload_page_for_garage !== 'undefined' && reload_page_for_garage) {
                        if (typeof reload_page_for_garage_cliar_url !== 'undefined' && reload_page_for_garage_cliar_url) {
                            history.pushState({}, '', main_url);
                        }
                        document.location.reload(true);
                    }
                }

                activeTabFirst();
            }
        });
    });

    $(document).on('click', '.js__remove_car', function () {
        let carId = $(this).attr('data-idCar');
        const wrapper = $(this).closest('.garage_item');

        $.post(request.removeGarageCar, {
            "car_id": carId,
            "type_menu_build": typeof type_menu_build !== 'undefined' ? type_menu_build : undefined,
        }, function (data) {
            if (data.status == 'ok') {
                wrapper.remove();

                $("#js__view_garage").empty().append(data.html);
                if ($('.js__catalog_main_page').length > 0) {
                    $('.js__catalog_main_page').empty().append(data.menu);
                    activeHoverMainPageMenu();
                }
                $('.bg_modal_window').trigger('click');
                $('body').removeClass('overflow_hidden');

                if ($('.js_brand_id').length != 0) {
                    activeMyGarage('remove');
                }

                if (typeof reload_page_for_garage !== 'undefined' && reload_page_for_garage) {
                    if (typeof reload_page_for_garage_cliar_url !== 'undefined' && reload_page_for_garage_cliar_url) {
                        history.pushState({}, '', main_url);
                    }
                    document.location.reload(true);
                }
            }
        });
    });

    $(document).on('click', '.js__open_garage_list_btn', function () {
        if ($(window).outerWidth() > 768) {
            const btn = $(this);
            btn.toggleClass('open');
            btn.closest('.your_cars')
                .find('.js__garage_list').slideToggle('slow');
        }
    })

    $(document).on('click', '.js__active_car', function () {
        let carId = $(this).attr('data-idCar');
        let name = $(this).html();
        let wrapper = $(this).closest('.your_cars');

        $('.js__active_car').removeClass('active');
        $(this).addClass('active');

        $.post(request.setActiveGarageCar, {
            "car_id": carId,
            "type_menu_build": typeof type_menu_build !== 'undefined' ? type_menu_build : undefined,
        }, function (data) {
            if (data.status == 'ok') {
                wrapper.find('.js__open_garage_list_btn').removeClass('open');
                if ($(window).outerWidth() > 768) {
                    wrapper.find('.js__garage_list').slideUp('slow');
                }

                $('.js__open_garage_list_btn').empty().html(name);

                $("#js__view_garage").empty().append(data.html);

                if ($('.js__catalog_main_page').length > 0) {
                    $('.js__catalog_main_page').empty().append(data.menu);
                    activeHoverMainPageMenu();
                }
                $('.bg_modal_window').trigger('click');
                $('body').removeClass('overflow_hidden');

                if ($('.js_brand_id').length != 0) {
                    activeMyGarage('remove');
                }

                if (typeof reload_page_for_garage !== 'undefined' && reload_page_for_garage) {
                    if (typeof reload_page_for_garage_cliar_url !== 'undefined' && reload_page_for_garage_cliar_url) {
                        history.pushState({}, '', main_url);
                    }
                    document.location.reload(true);
                }
            }
        });
    });

    $(document).click(function (event) {
        var $target = $(event.target);

        if (!$target.closest('.your_cars').length) {
            var btn = $('.js__open_garage_list_btn');

            if (btn.hasClass('open')) {
                btn.removeClass('open');
                btn.closest('.your_cars')
                    .find('.js__garage_list').slideUp('slow');
            }
        }
    });

    $(document).on('click', '.js__is_car_garage', function (e) {
        e.stopPropagation();
        $(this).toggleClass('active');

        if ($(this).hasClass('active')) {
            $('.js__active_car:not([data-idcar=all])').first().trigger('click');
        } else {
            $('.js__active_car[data-idcar=all]').trigger('click');
        }
    })
});

function activeMyGarage(flag = false) {
    if (flag == 'remove') {
        $('.js_brand_id').removeClass('js_stop');
        if (flag == 'true' && $('.js_brand_id:not(.js_stop)').length == 1) {
            const modelId = $('.js_brand_id').attr('data-modelId');
            $(`.js__garage_select[data-target_type=years][data-value=${modelId}]`).trigger('click');
            $('.js_brand_id').addClass('js_stop');

        } else if ($('.js_brand_id:not(.js_stop)').length == 1) {
            const brendId = $('.js_brand_id').attr('data-brandId');
            $(`.js__garage_select[data-target_type=model_lists][data-value=${brendId}]`).trigger('click');
        }
    } else {
        if (flag && $('.js_brand_id:not(.js_stop)').length == 1) {
            const modelId = $('.js_brand_id').attr('data-modelId');
            $(`.js__garage_select[data-target_type=years][data-value=${modelId}]`).trigger('click');
            $('.js_brand_id').addClass('js_stop');
        } else if ($('.js_brand_id:not(.js_stop)').length == 1) {
            const brendId = $('.js_brand_id').attr('data-brandId');
            $(`.js__garage_select[data-target_type=model_lists][data-value=${brendId}]`).trigger('click');

        }
    }
}

function activeTabFirst() {
    $('.js_button_tab:is(:disabled)').length == 3
        ? $('.js_button_tab:nth-child(1)').addClass('active_tab')
        : $('.js_button_tab:nth-child(1)').removeClass('active_tab');
}